module.exports = __webpack_public_path__ + "static/media/kategorisaljare.a9573024.jpg";